import BaseApi from "./BaseApi";
import RefreshTokenApi from "./RefreshTokenApi";
import { IUserLogged } from "../interfaces";
import StorageService from "./StorageService";
import { Roles } from "../contants";
import environment from "./../environment";
import BaseEmptyApi from "./BaseEmptyApi";

class AuthService {

    public login(command: any) {
        return BaseApi.post("api/account/app/Login", command);
    }

    public async LoginbyToken(command: any): Promise<any> {
        return await BaseApi.post("api/account/app/LoginbyToken", command);
    }

    public loginTwoFactor(command: any, token: string) {
        return BaseEmptyApi.post(
            `${environment.api}api/account/login/two-factor`,
            command,
            {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }
        ).then((x) => x.data.data);
    }

    public refreshToken(): Promise<any> {
        return RefreshTokenApi.post("api/account/app/refresh-token");
    }

    public revokeToken(): Promise<any> {
        return RefreshTokenApi.post("api/account/app/revoke-token");
    }

    public putPasswordAsync(request: any) {
        return BaseApi.put(`api/account/password`, request);
    }

    public postRecoveryPasswordAsync(request: any) {
        return BaseApi.post(`api/account/recovery-password/request`, request);
    }

    public getVerifyCodeRecoveryPasswordAsync(token: string, document: string | null, email: string | null) {
        return BaseApi.post(`api/account/recovery-password/verify`, {
            token,
            document,
            email
        });
    }

    public postRecoveryPasswordConfirmAsync(document: string | null, email: string | null, token: string, newPassword: string) {
        return BaseApi.post('api/account/recovery-password', {
            document,
            email,
            token,
            newPassword,
        });
    }

    public logout() {
        StorageService.logOut();
    }

    public decodeJwt(token: string) {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );

        const oldTokenObject = JSON.parse(jsonPayload);
        let tokenObject: any = {};

        Object.keys(oldTokenObject).forEach((key) => {
            if (key.indexOf("http") !== -1) {
                tokenObject[key.split("/").slice(-1)[0]] = oldTokenObject[key];
            } else {
                tokenObject[key] = oldTokenObject[key];
            }
        });

        return tokenObject;
    }

    public setUserLogged(token: string, refreshToken: string, device: string | null): Promise<IUserLogged> {
        return new Promise((resolve, reject) => {
            try {
                const tokenObject = this.decodeJwt(token);
                StorageService.setUserLogged({
                    email: tokenObject.emailaddress,
                    name: tokenObject.name,
                    id: tokenObject.sid,
                    twoFactorEnabled: tokenObject.twoFactorEnabled === "1",
                    roles:
                        typeof tokenObject.role === "string"
                            ? [tokenObject.role]
                            : tokenObject.role,
                    userName: tokenObject.userName,
                    avatar: tokenObject?.avatar,
                    alreadyCreatedGoal: tokenObject.alreadyCreatedGoal === "1",
                    device: device
                } as IUserLogged);
                StorageService.setToken(token);
                StorageService.setRefreshToken(refreshToken);
                resolve(StorageService.getUserLogged()); // Indicate the operation was successful
            } catch (error) {
                reject(error); // Indicate there was an error
            }
        });
    }
    public isLoggedIn(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            try {
                let currentToken = StorageService.getToken();
                if (currentToken === null || currentToken === undefined) return resolve(false);
                StorageService.getUserLogged().then((user) => {
                    if (user === null || user === undefined) return resolve(false);
                    if (user.name === null) return resolve(false);
                    resolve(true);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    public hasPermission(roles?: Roles[]): Promise<boolean> {
        return new Promise((resolve, reject) => {
            try {
                if (!roles || roles.length === 0) return resolve(true);
                StorageService.getUserLogged().then((res) => {
                    if (res === null) {
                        StorageService.logOutForLogin();
                        resolve(false);
                    }
                    const hasPermission = roles.some((role) =>
                        res.roles.some((userRole) => userRole === role)
                    );
                    resolve(hasPermission);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

}

const authService = new AuthService();

export default authService;
